import * as LocationActions from './location'
import { fetchGuideFile } from '../utilities/service-utils'
import config from '../config'
import 'isomorphic-fetch'
import * as Roles from '../constants/roles'
import { push } from 'connected-react-router'


export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILED = 'LOGIN_FAILED'
export const ERROR_LOGIN = 'ERROR_LOGIN'
export const LOGOUT = 'LOGOUT'
export const INITITAL_LOGIN = 'INITITAL_LOGIN'


export const REFRESH = 'REFRESH'

export const TOKEN_REFRESH_OFFSET = 30000;  // How soon before the session expires to refresh the token.  In milliseconds.

let authtimer = ''


export const initialLogin = (initialLogin) => {
  return {
    type: INITITAL_LOGIN,
    initialLogin
  }
}

/**
 * 
 * @param {*} userId 
 * @param {*} password 
 * @param {*} source 
 * @returns 
 */
export const logIn = (userId, password, source) => (dispatch) => {
    // console.log("[actions.user] login  source=",source)
if('idp' === source) {
  //  console.log('^^^^^^^^ external user -- DB authentication -- IDP style ^^^^^^^^^^^ ')
  return fetch(`${config.ENDPOINT}/auth/authenticateIDP`, {
    headers: {
      //Authorization: config.AUTHORIZATION,
      'cache-control': 'no-cache',
      pragma: 'no-cache',
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body: JSON.stringify({
      username: userId,
      password: window.btoa(password)
    })
  }).then((res) => {
    // console.log('[actions/user.js] - (EXTERNAL) logIn returned res: ',res)
    return res.json()
  }).then((response) => {
    // console.log('[actions/user.js] - response: ',response)
    const data = response.data || {}
    // console.log('^^^^^^^^^^^^^^^^^^^ ' + data)
    
    // console.log('Role=', data.role)
    // console.log('Carrier=', data.carrierAbbr)
    if (response.status !== 'success'
    ||((data.role !== Roles.CARRIER) && (data.role !== Roles.AGENT)) 

    ) {
      dispatch({
        type: LOGIN_FAILED,
        message: 'Invalid username/password, or External user has not been approved'
      })

      return false
    }

    // console.log('[actions/user.js] - logIn succeeded')      
    // console.log('[actions/user.js] - logIn succeeded')   
    dispatch({
      type: LOGIN_SUCCESS,
      userId,
      role: data.role,
      entityType: data.entityType,
      carrier: data.carrierAbbr,
      agency: data.agencyAbbr,
      authToken: data.authToken,
      authExpiry: data.authTokenExpiry,
      tokenAssignTime: data.accessDateMillis
      // ,superSecretKey: data.superSecretKey
    })

    authtimer = setTimeout(
      ()=>{
        dispatch(refreshToken())}, 
        (data.authTokenExpiryMillis - data.accessDateMillis) - TOKEN_REFRESH_OFFSET
  );


    return true
  }).catch((e) => {
    // console.log('********************* ' + e)
    dispatch({
      type: LOGIN_FAILED,
      message: 'Unable to contact Spring service for DB auth, IDP-style'
    })
    return false
  })
}


}

export const mfaAuthenticate = (authcode, redurl) => (dispatch) => {
  return fetch(`${config.ENDPOINT}/auth/mfaAuthenticate`,
    {method: 'post',
     body: JSON.stringify({code: authcode, redirectUrl: redurl}),
      headers: new Headers({'content-type' : 'application/json'})
    })        .then((res) => res.json())
    .then((res) => {
      if(res.message === 'User Found'){
            dispatch({
              type: LOGIN_SUCCESS,
              userId: res.data.userId,
              role: res.data.role,
              userName: res.data.username,
              authToken: res.data.authToken,
              authExpiry: res.data.authTokenExpiryMillis,
              tokenAssignTime: res.data.accessDateMillis
            })

            authtimer = setTimeout(
              ()=>{
                dispatch(refreshToken())},
                (res.data.authTokenExpiryMillis - res.data.accessDateMillis) - TOKEN_REFRESH_OFFSET
          );

            
           
      } else {
        let errMsg = ''
        if (res.message.includes('LDAP: error')) {
          errMsg = 'Authentication Error -- ' + res.message
        } else if (res.message.includes('LdapErr2')) {
          errMsg = 'Authorization Error -- ' + res.message
        } else if (res.message.includes('CommunicationException')) {
          errMsg = 'Communication Error between LDAP ans App Server -- ' + res.message
        } else {
          errMsg = res.message
        }
        
        dispatch({
          type: ERROR_LOGIN,
          errMsg: errMsg
        })

      }

      // const msg=res.message
      return new Promise((resolve) => {
        setTimeout(() => resolve(res.message), 500)
      })
    })
    .catch((err)=>{
      console.log(err)  

      dispatch({
        type: ERROR_LOGIN,
        errMsg: 'UnknownException'
      })

    })
}


export const refreshToken = () => (dispatch, getState) =>{
  const state = getState()
  // console.log('refreshToken')
  // console.log('state=',state)
  const user = state.user.userId;
  const token = state.user.authToken;
  // console.log('USER TOKEN REFRESH CALLED')
  // console.log('user', user)
  // console.log('token', token)
  clearInterval(authtimer)
  return fetch(`${config.ENDPOINT}/auth/refreshauthtoken`,
  {method: 'post',
   body: JSON.stringify({userId: user, authToken: token}),
    headers: new Headers({'Authorization': state.user.authToken,
                          'content-type' : 'application/json'})
  }).then((res) => {
    // console.log('USER TOKEN REFRESH -- res', res)
  return res.json()
}).then((res) => {
  // console.log('USER TOKEN REFRESH -- res', res)
    if(res.message === 'Validated'){
      dispatch({
        type: REFRESH,
        authToken: res.data.authToken,
        authExpiry: res.data.authTokenExpiryMillis,
        tokenAssignTime: res.data.accessDateMillis
      })
      // console.log('RESFRESHED TOKEN WILL BE Timing out in millis',(res.data.authTokenExpiryMillis - res.data.accessDateMillis) - TOKEN_REFRESH_OFFSET);

      // console.log('authTokenExpiryMillis', res.data.authTokenExpiryMillis);
      // console.log('accessDateMillis', res.data.accessDateMillis);      
      // console.log('authTokenExpiryMillis - accessDateMillis',res.data.authTokenExpiryMillis - res.data.accessDateMillis);
      // console.log(' - '+TOKEN_REFRESH_OFFSET, (res.data.authTokenExpiryMillis - res.data.accessDateMillis) - TOKEN_REFRESH_OFFSET)

      authtimer = setTimeout(()=>{
          dispatch(refreshToken())
      }, (res.data.authTokenExpiryMillis - res.data.accessDateMillis) - TOKEN_REFRESH_OFFSET);
    }
  })
}

/**
 * 
 * @returns 
 */

export const logOut = () => {
  return {
    type: LOGOUT
  }
}

export const downloadGuide = (guide) => (dispatch) => {
  fetchGuideFile('hazmat/downloadGuide',guide)
}

